import { render } from "./ApplicationStatus.vue?vue&type=template&id=5c3248ac&scoped=true&ts=true"
import script from "./ApplicationStatus.vue?vue&type=script&lang=ts"
export * from "./ApplicationStatus.vue?vue&type=script&lang=ts"

import "./ApplicationStatus.vue?vue&type=style&index=0&id=5c3248ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3248ac"]])

export default __exports__